import * as React from 'react';
import { InputGroup, FormControl } from 'react-bootstrap';
import FaIcon from './FaIcon';

interface IFilterBoxProps {
  placeholder?: string;
  onChange: (event: React.FormEvent<FormControl>) => void;
}

/** Standard Filterbox zur Suche in Listen */
export default class FilterBox extends React.Component<IFilterBoxProps, {}> {
  render() {
    return (
      <InputGroup className="filter-group">
        <InputGroup.Addon><FaIcon icon="search" /></InputGroup.Addon>
        <FormControl
          type="text"
          maxLength={64}
          onChange={this.props.onChange}
          placeholder={this.props.placeholder ? this.props.placeholder : 'Suchen'}
          className="filter-box"
        />
      </InputGroup>
   );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/site/FilterBox.tsx